var map = {
	"./20200216151451qevv@2x.png": "7a21",
	"./3D动画制作.png": "824e",
	"./3WCOFFEE.png": "7b0b",
	"./3dcartoon1.png": "8d7c",
	"./3dcartoon2.png": "ce01",
	"./3icon.png": "b97a",
	"./5G通讯数字展厅.png": "413a",
	"./Icon4.png": "5744",
	"./MR1.png": "7c1d",
	"./MR2.png": "ecaa",
	"./MR技术系统开发.png": "de1b",
	"./Servicetrade.png": "7068",
	"./aboutUS.png": "6564",
	"./accuracy.png": "a40c",
	"./adverst.png": "79b1",
	"./arrows-right.png": "d16f",
	"./arrows.png": "045f",
	"./arrows1.png": "4f56",
	"./banner1.png": "2633",
	"./boya.png": "cc3d",
	"./bqzk.png": "60b4",
	"./ckxz.png": "0e94",
	"./commonimg.png": "0273",
	"./community.png": "70d2",
	"./company.png": "bafa",
	"./companymap.png": "4127",
	"./contactus.png": "755e",
	"./culture.png": "bf32",
	"./design.png": "0c25",
	"./digitalpeople1.png": "2e97",
	"./digitalpeople2.png": "1db1",
	"./digitalsystem1.png": "2647",
	"./digitalsystem2.png": "f0ea",
	"./digitaltwin1.png": "f61c",
	"./digitaltwin2.png": "5432",
	"./domain.png": "95bf",
	"./dominate1.png": "7325",
	"./dominate2.png": "9191",
	"./feature1.png": "e774",
	"./feature2.png": "d8ea",
	"./feature3.png": "5a52",
	"./feature4.png": "47c2",
	"./feature5.png": "f38a",
	"./feature6.png": "2cb17",
	"./hxhq.png": "b09e",
	"./icon-comma.png": "35a3",
	"./icon-star.png": "05c6",
	"./icon.png": "f0fc",
	"./icon2.png": "e82b",
	"./icon3.png": "b23c",
	"./icon_email.png": "90de",
	"./icon_phone.png": "15da",
	"./infiared.png": "bb29",
	"./interactivegames1.png": "4bdd",
	"./interactivegames2.png": "c505",
	"./jqjs.png": "bd84",
	"./location.png": "9076",
	"./logo.png": "4ffd",
	"./logo1 拷贝@2x.png": "2e54",
	"./metaverse1.png": "36ed",
	"./metaverse2.png": "ab94",
	"./module.png": "d3ce",
	"./multimedia1.png": "dfb5",
	"./multimedia2.png": "dfaa",
	"./newmedia1.png": "1d85",
	"./newmedia2.png": "8647",
	"./news.png": "ea02",
	"./newsdynamic.png": "cb8c",
	"./originality.png": "205b",
	"./ornament.png": "c730",
	"./p22@2x.png": "2cb1",
	"./phone.png": "9347",
	"./projectcase.png": "b536",
	"./qq@2x.png": "94b1",
	"./recognition1.png": "412c",
	"./recognition2.png": "b037",
	"./science.png": "8da5",
	"./system1.png": "b43c",
	"./system2.png": "6a6d",
	"./technology1.png": "d8a2",
	"./technology10.png": "d57a",
	"./technology11.png": "a63c",
	"./technology12.png": "ae04",
	"./technology2.png": "2d4a",
	"./technology3.png": "2cec",
	"./technology4.png": "765c",
	"./technology5.png": "ee08",
	"./technology6.png": "7302",
	"./technology7.png": "fbd8",
	"./technology8.png": "0a70",
	"./technology9.png": "5bc1",
	"./weixinx@2x.png": "129e",
	"./whitebox.png": "b38f",
	"./wxicon.png": "9c6b",
	"./xiqu.png": "23f4",
	"./一带一路数字展厅 (1).png": "1522",
	"./一带一路数字展厅.png": "b893",
	"./三维制作画面.png": "eea5",
	"./三维制作画面1.png": "9338",
	"./三维制作画面2.png": "9503",
	"./三维制作画面3.png": "b78b",
	"./三维制作画面4.png": "3f01",
	"./三维制作画面5.png": "f1b9",
	"./中国版“迪士尼”.png": "8dd3",
	"./为什么选择我们白板.png": "5ff5",
	"./互动投影.png": "fb9f",
	"./互动投影new.png": "644a",
	"./产品体验中心.png": "a0aa",
	"./企业展示馆.png": "05d7",
	"./企业邮箱.png": "e9b5",
	"./会展.png": "b3751",
	"./会议.png": "0c8a",
	"./元宇宙系统开发.png": "5717",
	"./党建展厅.png": "4c95",
	"./全息成像.png": "be7e",
	"./全息成像1.png": "4ee9",
	"./全景运展云.png": "8d65",
	"./公共安全馆.png": "0946",
	"./公司地址.png": "4ba8",
	"./双箭头.png": "e4d8",
	"./品牌展示.png": "16cf",
	"./国家电网展厅.png": "7281",
	"./图书馆.png": "13c6",
	"./图标背景.png": "7466",
	"./地产.png": "301b",
	"./场馆展示1.png": "f1ec",
	"./场馆展示2.png": "a5bb",
	"./场馆展示3.png": "ef99",
	"./场馆展示后蓝背景.png": "2cdc",
	"./城市规划馆.png": "89b1",
	"./声光电系统施工.png": "da0c",
	"./多媒体展示厅.png": "e319",
	"./多媒体显示屏.png": "cce0",
	"./多媒体显示屏new.png": "2552",
	"./夜游.png": "a614",
	"./大健康养老产业展厅.png": "254f",
	"./大唐萌宫.png": "54f7",
	"./大数据体验厅.png": "c5d3",
	"./头图.png": "39f6",
	"./定制开发.png": "0f59",
	"./定制开发1.png": "f6d9",
	"./展览.png": "fc91",
	"./展馆智能中控.png": "1306",
	"./工程案例.png": "f1a1",
	"./年度重点项目.png": "a0c0",
	"./开发区规划馆.png": "4a5f",
	"./投影交互游戏开发.png": "7fd5",
	"./指挥中心.png": "ba2c",
	"./播放.png": "56d7",
	"./数字人系统定制.png": "5067",
	"./数字内容创意.png": "fa6d",
	"./数字内容创意1.png": "f178",
	"./数字化图书馆 (1).png": "1819",
	"./数字化图书馆.png": "ee7d",
	"./数字化系统定制.png": "8965",
	"./数字孪生系统开发.png": "3a90",
	"./数字影院.png": "3a7c",
	"./数字沙盘.png": "c1e0",
	"./文创.png": "9842",
	"./文化icon.png": "4ec6",
	"./文化旅游展厅.png": "e77f",
	"./文化遗产展馆.png": "4a97",
	"./文字背景.png": "c651",
	"./文旅.png": "aaad",
	"./新媒体实验室.png": "900c",
	"./新媒体实验室new.png": "fd99",
	"./新媒体实验室首图.png": "3ef1",
	"./智慧农业展厅.png": "b3f7",
	"./智慧城市展馆.png": "aace",
	"./智慧气象展厅.png": "f4d7",
	"./智慧银行数字化展厅.png": "2d84",
	"./智能手工课堂1.png": "6396",
	"./智能手工课堂2.png": "78ac",
	"./智能控制系统定制.png": "aba6",
	"./智能识别系统定制.png": "d7d9",
	"./机械开合旋转.png": "931d",
	"./校史馆.png": "56c9",
	"./梯形背景.png": "9c8d",
	"./次元兽决战1.png": "1a22",
	"./次元兽决战2.png": "f1d9",
	"./次元兽决战3.png": "66be",
	"./欢迎咨询1.png": "29a0",
	"./欢迎咨询3.png": "a58e",
	"./法制教育展厅.png": "0e88",
	"./波浪背景.png": "9856",
	"./灰背景.png": "a7b4",
	"./特色创新.png": "0555",
	"./特色创新1.png": "de8a",
	"./电网.png": "bdc4",
	"./白板投影.png": "efac",
	"./禁毒教育展厅.png": "cf91",
	"./科技馆.png": "0874",
	"./科普体验中心.png": "6808",
	"./科普馆.png": "6c88",
	"./红箭头.png": "508d",
	"./联系我们2.png": "8ece",
	"./联系电话.png": "7072",
	"./航空航天展厅.png": "0c03",
	"./萌乐天.png": "ba81",
	"./萌唐唐.png": "e8ab",
	"./萌唐唐诗会1.png": "609c",
	"./萌唐唐诗会2.png": "24f0",
	"./萌唐唐诗会3.png": "c333",
	"./萌宫天街.png": "8bc4",
	"./萌宫天街1.png": "c9f8",
	"./萌宫天街2.png": "7b39",
	"./萌宫天街3.png": "5490",
	"./萌小乖.png": "cfde",
	"./萌小乙.png": "9bc7",
	"./萌小白.png": "c47f",
	"./萌龙龙.png": "9709",
	"./诗仙会客厅.png": "7ff0",
	"./诗仙会客厅1.png": "732f",
	"./诗仙会客厅2.png": "4adb",
	"./诗仙会客厅3.png": "8a85",
	"./透明版装饰.png": "b43f",
	"./重点项目之一.png": "d67f",
	"./防灾体验.png": "da15",
	"./院史馆.png": "1468"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";